import { useSelector } from 'react-redux';
import { selectTaxesDisplaySetting } from '@gandi/authentication';
import { useTranslator } from '@gandi/translate';
import { selectRawBundleById } from '../../../../../modules/bundles';
export function useGetCartBundlePrice() {
  const taxesIncluded = useSelector(selectTaxesDisplaySetting);
  return bundle => bundle[taxesIncluded ? 'priceAfterTaxes' : 'priceBeforeTaxes'];
}
export function useGetCartTotalPrice() {
  const taxesIncluded = useSelector(selectTaxesDisplaySetting);
  return cartTotal => cartTotal[taxesIncluded ? 'afterTaxes' : 'beforeTaxes'];
}
export function useGetTotalPrice() {
  const taxesIncluded = useSelector(selectTaxesDisplaySetting);
  return total => total[taxesIncluded ? 'after_taxes' : 'before_taxes'];
}
export function useGetComputedTotalPrice() {
  const taxesIncluded = useSelector(selectTaxesDisplaySetting);
  return computedTotal => taxesIncluded ? computedTotal.beforeTaxes * (1 + computedTotal.rate / 100) : computedTotal.beforeTaxes;
}
export function useBundleDescription(bundle) {
  const {
    __
  } = useTranslator();
  const rawBundle = useSelector(state => selectRawBundleById(state, bundle.id));
  const isWP1ClickBundle = rawBundle?.type === 'WP1CLICK';
  const isDomainBundle = !rawBundle?.is_partial_type && bundle.products.every(product => product.productType === 'domain');
  if (isWP1ClickBundle) {
    return __('WordPress hosting');
  }
  if (isDomainBundle) {
    return __('Domain bundle');
  }
  return __('-50%% Hosting + free .fr - 12 months');
}